import { useState } from "react";
import { faqItems } from "@/mocks/manhwaData";

export default function Faq() {
  const [open, setOpen] = useState<string | null>("f1");

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">韩漫网址导航常见问题</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            关于本站的使用、收藏与收录，这里都有答案。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqItems.map((item) => {
            const isOpen = open === item.id;
            return (
              <article
                key={item.id}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50/60"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : item.id)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900 md:text-base">
                    <i className={`ri-question-line ${isOpen ? "text-primary-500" : "text-secondary-500"}`}></i>
                    {item.q}
                  </h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-transform ${
                      isOpen ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}